import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { finApi, finErr, money, LEDGER_BUCKETS, BUCKET_LABEL } from "@/lib/financeApi";

export default function BalancesTab({ resident }) {
  const [state, setState] = useState({ loading: true, balances: null, total: 0, error: null });
  useEffect(() => {
    finApi.get(`/residents/${resident.id}/balances`)
      .then((d) => setState({ loading: false, balances: d.balances, total: d.total, error: null }))
      .catch((e) => setState({ loading: false, balances: null, total: 0, error: finErr(e) }));
  }, [resident.id]);

  if (state.loading) return <div data-testid="fin-balances-loading" className="p-10 text-center text-nex-muted"><Loader2 className="inline h-4 w-4 animate-spin" /></div>;
  if (state.error) return <p data-testid="fin-balances-error" className="p-10 text-center text-red-300 text-sm">{state.error}</p>;
  return (
    <div data-testid="fin-balances-tab" className="p-5 space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {LEDGER_BUCKETS.map((b) => {
          const v = state.balances[b];
          return (
            <div key={b} className="p-4 border border-white/10 rounded-sm bg-white/[0.02]">
              <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-nex-muted">{BUCKET_LABEL[b]}</div>
              <div data-testid={`fin-balance-${b}`} className={`mt-2 font-mono text-xl ${v < 0 ? "text-red-300" : v > 0 ? "text-nex-gold" : "text-nex-muted"}`}>{money(v)}</div>
            </div>
          );
        })}
      </div>
      <div className="flex items-center justify-between px-4 py-3 border border-nex-gold/30 rounded-sm">
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Net across buckets</span>
        <span data-testid="fin-balance-total" className="font-mono text-lg text-nex-silver">{money(state.total)}</span>
      </div>
      <p data-testid="fin-balance-net-note" className="text-[11px] text-nex-muted">Balances are derived live from the append-only ledger. Nothing is stored on the resident. PACT Fee and Payroll are running totals and are left out of the net.</p>
    </div>
  );
}
